import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
/**
 * Wrap any £ amount or count to enable tabular figures.
 * Uses the .numeric utility from the design-tokens preset.
 */
export function Numeric({ serif, className, children, ...rest }) {
    return (_jsx("span", { "data-slot": "numeric", className: cn("numeric", serif && "font-serif text-ink-900", className), ...rest, children: children }));
}
